import React from 'react';

export const HOME_PAGE_ROUTE = '/';

export function HomePage(): JSX.Element {
  return <h1 className="text-center">Welcome to CAPE</h1>;
}
